import React from "react"
import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import MovieCollection from "./components/MovieCollection";
import { useState, useEffect } from "react"
import qs from "qs"
import { createBrowserHistory } from "history"

function App() {
  const [streamingService, setStreamingService] = useState("")
  const [containerVisibility, setContainerVisibility] = useState(false)

  const history = createBrowserHistory()

  // https://blog.bitsrc.io/5-methods-to-persisting-state-between-page-reloads-in-react-8fc9abd3fa2f
  useEffect(() => {
    const filterParams = history.location.search.substr(1)
    const filtersFromParams = qs.parse(filterParams)
    if (filtersFromParams.service) {
      if (filtersFromParams.service.includes("Disney")) {
        setStreamingService("Disney +")
      } else {
        setStreamingService(filtersFromParams.service)
      }
    }
  }, [history.location.search])

  const handleClick = () => {
    setContainerVisibility(prevValue => !prevValue)
  }

  const filterStreamingService = (streamingService) => {
    history.push("?service=")
    setStreamingService(streamingService)
    setContainerVisibility(prevValue => !prevValue)
  }

  const streamingButtons = () => {
    const services = ["HBO MAX", "Netflix", "Peacock", "Hulu", "Disney +", "Apple TV", "YouTube", "Prime Video", "Theaters", "All Streaming Services"]

    const buttons = services.map(service => {
      return (
        <li 
          key={service}>
            <button 
              className="light-background-color" 
              onClick={() => filterStreamingService(service === "All Streaming Services" ?  "" : service)}>{service}
            </button>
        </li>
      )
    })

    return buttons
  }

  return (
        <div>
          <Navbar title="Entertainment" showFilter={true} handleClick={handleClick}/>
          <Banner />
          {
            <div className="streaming-service-title-container">
              <h2 className="streaming-service-title">{streamingService ? streamingService : "All Streaming Services"}</h2>
            </div>
          }
          <MovieCollection streamingService={streamingService}/>
          {
            containerVisibility && 
             <div className="streaming-services-container extra-dark-background-color">
               <ul className="streaming-services-list">
                 {streamingButtons()}
               </ul>
             </div>
          }
        </div>
  );
}

export default App;
